import { combineReducers } from "redux";

import userData from "./Users/reducer";
import serviceTypes from "./ServiceTypes/reducer";

const rootReducer = combineReducers({
  userData,
  serviceTypes,
});

export default rootReducer;
